<template>
  <!-- <div>
    <router-link to="/">Home</router-link>
    <router-link to="/About">About Us</router-link>
    <router-link to="/topiccreate">topic Create/update</router-link>
    <router-link to="/callerscreen">CallerScreen</router-link>
  </div> -->
  <div>
    <header>
      <nav class="navbar navbar-expand-lg navbar-light bg-nav">
        <router-link class="navbar-brand logo" :to="userName ? '/dashboard' : '/'" title="The incircle"
          data-toggle="tooltip">
          <img src="@/assets/images/logo-hin.png" />
        </router-link>
        <div class="employee-icon disNone" v-if="!userName && currentPath !== '/post-job'">
          <img src="@/assets/images/icons/user.svg" alt="user" @click="clickOnLogin" />
        </div>
        <div class="employee-icon disNone" v-if="userName && currentPath !== '/post-job'">
          <img src="@/assets/images/icons/user.svg" alt="user" @click="clickOnCompProf" />
        </div>
        <button class="navbar-toggler" type="button" style="border:none" data-toggle="collapse"
          data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation">
          <img src="@/assets/images/icons/drawer.svg" alt="drawer" />
          <!-- <span class="navbar-toggler-icon"></span> -->
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav" v-if="!userName">
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/hireemployee" data-toggle="tooltip" title="Settings"><svg width="17"
                  height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.1074 6.26267L14.854 6.10333C14.7507 5.78533 14.6234 5.47867 14.4747 5.18733L15.2487 4.19067C15.562 3.78733 15.5254 3.218 15.1674 2.87133L14.1174 1.82133C13.7674 1.46 13.198 1.424 12.794 1.73667L11.7987 2.51067C11.5074 2.362 11.2007 2.23467 10.882 2.13133L10.7227 0.88C10.6627 0.378 10.2367 0 9.73202 0H8.23869C7.73402 0 7.30802 0.378 7.24802 0.878L7.08869 2.13133C6.77002 2.23467 6.46335 2.36133 6.17202 2.51067L5.17602 1.73667C4.77335 1.424 4.20402 1.46 3.85669 1.818L2.80669 2.86733C2.44535 3.218 2.40869 3.78733 2.72202 4.19133L3.49602 5.18733C3.34669 5.47867 3.22002 5.78533 3.11669 6.10333L1.86535 6.26267C1.36335 6.32267 0.985352 6.74867 0.985352 7.25333V8.74667C0.985352 9.25133 1.36335 9.67733 1.86335 9.73733L3.11669 9.89667C3.22002 10.2147 3.34735 10.5213 3.49602 10.8127L2.72202 11.8093C2.40869 12.2127 2.44535 12.782 2.80335 13.1287L3.85335 14.1787C4.20402 14.5393 4.77269 14.5753 5.17669 14.2627L6.17269 13.4887C6.46402 13.638 6.77069 13.7653 7.08869 13.868L7.24802 15.1187C7.30802 15.622 7.73402 16 8.23869 16H9.73202C10.2367 16 10.6627 15.622 10.7227 15.122L10.882 13.8687C11.2 13.7653 11.5067 13.638 11.798 13.4893L12.7947 14.2633C13.198 14.5767 13.7674 14.54 14.114 14.182L15.164 13.132C15.5254 12.7813 15.562 12.2127 15.2487 11.8087L14.4747 10.8127C14.624 10.5213 14.7514 10.2147 14.854 9.89667L16.1047 9.73733C16.6067 9.67733 16.9847 9.25133 16.9847 8.74667V7.25333C16.9854 6.74867 16.6074 6.32267 16.1074 6.26267ZM8.98535 11.3333C7.14735 11.3333 5.65202 9.838 5.65202 8C5.65202 6.162 7.14735 4.66667 8.98535 4.66667C10.8234 4.66667 12.3187 6.162 12.3187 8C12.3187 9.838 10.8234 11.3333 8.98535 11.3333Z"
                    fill="#0088C2" />
                </svg>
                Hire Staff</router-link>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/find-resume" data-toggle="tooltip" title="Notification"><svg width="17"
                  height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.65279 0.915527C4.19486 0.915527 0.568359 4.54202 0.568359 8.99996C0.568359 13.4579 4.19486 17.0844 8.65279 17.0844C13.1107 17.0844 16.7372 13.4579 16.7372 8.99996C16.7372 4.54202 13.1107 0.915527 8.65279 0.915527ZM12.1897 9.67362H9.32645V12.5369C9.32645 12.9088 9.02472 13.2106 8.65279 13.2106C8.28086 13.2106 7.97913 12.9088 7.97913 12.5369V9.67362H5.11585C4.74393 9.67362 4.44219 9.37188 4.44219 8.99996C4.44219 8.62803 4.74393 8.3263 5.11585 8.3263H7.97913V5.46302C7.97913 5.09109 8.28086 4.78936 8.65279 4.78936C9.02472 4.78936 9.32645 5.09109 9.32645 5.46302V8.3263H12.1897C12.5617 8.3263 12.8634 8.62803 12.8634 8.99996C12.8634 9.37188 12.5617 9.67362 12.1897 9.67362Z"
                    fill="#0088C2" />
                </svg>
                Find Resume</router-link>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/employer-plan" data-toggle="tooltip" title="Post Job"><svg width="18"
                  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.66309 0.907227H9.16504V8.90918H17.167V8.41113C17.167 4.29155 13.7827 0.907227 9.66309 0.907227Z"
                    fill="#0088C2" />
                  <path
                    d="M2.75977 16.0189C4.07441 17.1701 5.79021 17.9072 7.67104 17.9072C11.7906 17.9072 15.1417 14.5229 15.1417 10.4033V9.90527H8.87336L2.75977 16.0189Z"
                    fill="#0088C2" />
                  <path
                    d="M8.16888 2.93262H7.67084C6.04441 2.93262 4.54237 3.46081 3.31445 4.34657L8.16888 9.201V2.93262Z"
                    fill="#0088C2" />
                  <path
                    d="M2.54354 4.98413C1.10412 6.34672 0.166992 8.26935 0.166992 10.4033C0.166992 12.2841 0.904102 13.9999 2.05535 15.3146L7.46467 9.90527L2.54354 4.98413Z"
                    fill="#0088C2" />
                </svg>
                Plan for you</router-link>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/contact-us" data-toggle="tooltip" title="Post Job"><svg width="17"
                  height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.65279 0.915527C4.19486 0.915527 0.568359 4.54202 0.568359 8.99996C0.568359 13.4579 4.19486 17.0844 8.65279 17.0844C13.1107 17.0844 16.7372 13.4579 16.7372 8.99996C16.7372 4.54202 13.1107 0.915527 8.65279 0.915527ZM12.1897 9.67362H9.32645V12.5369C9.32645 12.9088 9.02472 13.2106 8.65279 13.2106C8.28086 13.2106 7.97913 12.9088 7.97913 12.5369V9.67362H5.11585C4.74393 9.67362 4.44219 9.37188 4.44219 8.99996C4.44219 8.62803 4.74393 8.3263 5.11585 8.3263H7.97913V5.46302C7.97913 5.09109 8.28086 4.78936 8.65279 4.78936C9.02472 4.78936 9.32645 5.09109 9.32645 5.46302V8.3263H12.1897C12.5617 8.3263 12.8634 8.62803 12.8634 8.99996C12.8634 9.37188 12.5617 9.67362 12.1897 9.67362Z"
                    fill="#0088C2" />
                </svg>
                Contact us</router-link>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <span class="nav-link login01" href="#" title="Post Job" @click="clickOnLogin"><svg width="14" height="15"
                  viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.2619 13.6597C13.2619 13.8948 13.1685 14.1204 13.0022 14.2866C12.8359 14.4529 12.6104 14.5463 12.3753 14.5463H1.7362C1.50106 14.5463 1.27555 14.4529 1.10929 14.2866C0.943018 14.1204 0.849609 13.8948 0.849609 13.6597C0.849609 12.2489 1.41006 10.8958 2.40767 9.89822C3.40528 8.90061 4.75832 8.34016 6.16916 8.34016H7.94234C9.35317 8.34016 10.7062 8.90061 11.7038 9.89822C12.7014 10.8958 13.2619 12.2489 13.2619 13.6597ZM7.05575 0.36084C6.35434 0.36084 5.66869 0.56883 5.08549 0.95851C4.5023 1.34819 4.04775 1.90206 3.77933 2.55007C3.51092 3.19808 3.44069 3.91114 3.57752 4.59907C3.71436 5.28699 4.05212 5.91889 4.54809 6.41486C5.04406 6.91083 5.67596 7.24859 6.36389 7.38543C7.05181 7.52226 7.76487 7.45203 8.41288 7.18362C9.06089 6.9152 9.61476 6.46065 10.0044 5.87746C10.3941 5.29426 10.6021 4.60861 10.6021 3.9072C10.6021 2.96665 10.2285 2.06462 9.56341 1.39955C8.89833 0.734473 7.9963 0.36084 7.05575 0.36084Z"
                    fill="#0088C2" />
                </svg>
                {{ userName ? userName : " Login" }}</span>
            </li>
            <!-- <li
              class="nav-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <router-link
                class="nav-link"
                data-toggle="tooltip"
                title="Register"
                to="/register"
                ><i class="fa fa-wpforms"></i> Register</router-link
              >
            </li> -->
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link active" to="/post-job" data-toggle="tooltip" title="Post Job"><svg width="17"
                  height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.65279 0.915527C4.19486 0.915527 0.568359 4.54202 0.568359 8.99996C0.568359 13.4579 4.19486 17.0844 8.65279 17.0844C13.1107 17.0844 16.7372 13.4579 16.7372 8.99996C16.7372 4.54202 13.1107 0.915527 8.65279 0.915527ZM12.1897 9.67362H9.32645V12.5369C9.32645 12.9088 9.02472 13.2106 8.65279 13.2106C8.28086 13.2106 7.97913 12.9088 7.97913 12.5369V9.67362H5.11585C4.74393 9.67362 4.44219 9.37188 4.44219 8.99996C4.44219 8.62803 4.74393 8.3263 5.11585 8.3263H7.97913V5.46302C7.97913 5.09109 8.28086 4.78936 8.65279 4.78936C9.02472 4.78936 9.32645 5.09109 9.32645 5.46302V8.3263H12.1897C12.5617 8.3263 12.8634 8.62803 12.8634 8.99996C12.8634 9.37188 12.5617 9.67362 12.1897 9.67362Z"
                    fill="#0088C2" />
                </svg>
                Post Job</router-link>
            </li>
          </ul>

          <ul class="navbar-nav" v-else>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/setting" data-toggle="collapse" title="Settings"><svg width="17"
                  height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.1074 6.26267L14.854 6.10333C14.7507 5.78533 14.6234 5.47867 14.4747 5.18733L15.2487 4.19067C15.562 3.78733 15.5254 3.218 15.1674 2.87133L14.1174 1.82133C13.7674 1.46 13.198 1.424 12.794 1.73667L11.7987 2.51067C11.5074 2.362 11.2007 2.23467 10.882 2.13133L10.7227 0.88C10.6627 0.378 10.2367 0 9.73202 0H8.23869C7.73402 0 7.30802 0.378 7.24802 0.878L7.08869 2.13133C6.77002 2.23467 6.46335 2.36133 6.17202 2.51067L5.17602 1.73667C4.77335 1.424 4.20402 1.46 3.85669 1.818L2.80669 2.86733C2.44535 3.218 2.40869 3.78733 2.72202 4.19133L3.49602 5.18733C3.34669 5.47867 3.22002 5.78533 3.11669 6.10333L1.86535 6.26267C1.36335 6.32267 0.985352 6.74867 0.985352 7.25333V8.74667C0.985352 9.25133 1.36335 9.67733 1.86335 9.73733L3.11669 9.89667C3.22002 10.2147 3.34735 10.5213 3.49602 10.8127L2.72202 11.8093C2.40869 12.2127 2.44535 12.782 2.80335 13.1287L3.85335 14.1787C4.20402 14.5393 4.77269 14.5753 5.17669 14.2627L6.17269 13.4887C6.46402 13.638 6.77069 13.7653 7.08869 13.868L7.24802 15.1187C7.30802 15.622 7.73402 16 8.23869 16H9.73202C10.2367 16 10.6627 15.622 10.7227 15.122L10.882 13.8687C11.2 13.7653 11.5067 13.638 11.798 13.4893L12.7947 14.2633C13.198 14.5767 13.7674 14.54 14.114 14.182L15.164 13.132C15.5254 12.7813 15.562 12.2127 15.2487 11.8087L14.4747 10.8127C14.624 10.5213 14.7514 10.2147 14.854 9.89667L16.1047 9.73733C16.6067 9.67733 16.9847 9.25133 16.9847 8.74667V7.25333C16.9854 6.74867 16.6074 6.32267 16.1074 6.26267ZM8.98535 11.3333C7.14735 11.3333 5.65202 9.838 5.65202 8C5.65202 6.162 7.14735 4.66667 8.98535 4.66667C10.8234 4.66667 12.3187 6.162 12.3187 8C12.3187 9.838 10.8234 11.3333 8.98535 11.3333Z"
                    fill="#0088C2" />
                </svg>
                Settings
              </router-link>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/employer-plan" data-toggle="tooltip" title="Plan"><svg width="18"
                  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.66309 0.907227H9.16504V8.90918H17.167V8.41113C17.167 4.29155 13.7827 0.907227 9.66309 0.907227Z"
                    fill="#0088C2" />
                  <path
                    d="M2.75977 16.0189C4.07441 17.1701 5.79021 17.9072 7.67104 17.9072C11.7906 17.9072 15.1417 14.5229 15.1417 10.4033V9.90527H8.87336L2.75977 16.0189Z"
                    fill="#0088C2" />
                  <path
                    d="M8.16888 2.93262H7.67084C6.04441 2.93262 4.54237 3.46081 3.31445 4.34657L8.16888 9.201V2.93262Z"
                    fill="#0088C2" />
                  <path
                    d="M2.54354 4.98413C1.10412 6.34672 0.166992 8.26935 0.166992 10.4033C0.166992 12.2841 0.904102 13.9999 2.05535 15.3146L7.46467 9.90527L2.54354 4.98413Z"
                    fill="#0088C2" />
                </svg>
                Plan
              </router-link>
            </li>

            <!-- <li
              class="nav-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <router-link
                class="nav-link"
                to="/notifications"
                data-toggle="tooltip"
                title="Notification"
                ><i class="fa fa-bell"></i> Notification
              </router-link>
            </li> 
            -->

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/post-job" data-toggle="tooltip" title="Post Job"><svg width="17"
                  height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.65279 0.915527C4.19486 0.915527 0.568359 4.54202 0.568359 8.99996C0.568359 13.4579 4.19486 17.0844 8.65279 17.0844C13.1107 17.0844 16.7372 13.4579 16.7372 8.99996C16.7372 4.54202 13.1107 0.915527 8.65279 0.915527ZM12.1897 9.67362H9.32645V12.5369C9.32645 12.9088 9.02472 13.2106 8.65279 13.2106C8.28086 13.2106 7.97913 12.9088 7.97913 12.5369V9.67362H5.11585C4.74393 9.67362 4.44219 9.37188 4.44219 8.99996C4.44219 8.62803 4.74393 8.3263 5.11585 8.3263H7.97913V5.46302C7.97913 5.09109 8.28086 4.78936 8.65279 4.78936C9.02472 4.78936 9.32645 5.09109 9.32645 5.46302V8.3263H12.1897C12.5617 8.3263 12.8634 8.62803 12.8634 8.99996C12.8634 9.37188 12.5617 9.67362 12.1897 9.67362Z"
                    fill="#0088C2" />
                </svg>
                Post Permanent Job</router-link>
            </li>

            <li class="nav-item text-nowrap" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link text-nowrap" to="/labour-contractor" data-toggle="tooltip"
                title="Post Contract Job">
                <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.65279 0.915527C4.19486 0.915527 0.568359 4.54202 0.568359 8.99996C0.568359 13.4579 4.19486 17.0844 8.65279 17.0844C13.1107 17.0844 16.7372 13.4579 16.7372 8.99996C16.7372 4.54202 13.1107 0.915527 8.65279 0.915527ZM12.1897 9.67362H9.32645V12.5369C9.32645 12.9088 9.02472 13.2106 8.65279 13.2106C8.28086 13.2106 7.97913 12.9088 7.97913 12.5369V9.67362H5.11585C4.74393 9.67362 4.44219 9.37188 4.44219 8.99996C4.44219 8.62803 4.74393 8.3263 5.11585 8.3263H7.97913V5.46302C7.97913 5.09109 8.28086 4.78936 8.65279 4.78936C9.02472 4.78936 9.32645 5.09109 9.32645 5.46302V8.3263H12.1897C12.5617 8.3263 12.8634 8.62803 12.8634 8.99996C12.8634 9.37188 12.5617 9.67362 12.1897 9.67362Z"
                    fill="#0088C2" />
                </svg>
                Post Payroll Jobs</router-link>
            </li>

            <li class="nav-item dropdown" data-toggle="collapse" data-target=".navbar-collapse.show">
              <a class="nav-link dropdown-toggle login accounts" href="#" id="navbarDropdownMenuLink"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.2619 13.6597C13.2619 13.8948 13.1685 14.1204 13.0022 14.2866C12.8359 14.4529 12.6104 14.5463 12.3753 14.5463H1.7362C1.50106 14.5463 1.27555 14.4529 1.10929 14.2866C0.943018 14.1204 0.849609 13.8948 0.849609 13.6597C0.849609 12.2489 1.41006 10.8958 2.40767 9.89822C3.40528 8.90061 4.75832 8.34016 6.16916 8.34016H7.94234C9.35317 8.34016 10.7062 8.90061 11.7038 9.89822C12.7014 10.8958 13.2619 12.2489 13.2619 13.6597ZM7.05575 0.36084C6.35434 0.36084 5.66869 0.56883 5.08549 0.95851C4.5023 1.34819 4.04775 1.90206 3.77933 2.55007C3.51092 3.19808 3.44069 3.91114 3.57752 4.59907C3.71436 5.28699 4.05212 5.91889 4.54809 6.41486C5.04406 6.91083 5.67596 7.24859 6.36389 7.38543C7.05181 7.52226 7.76487 7.45203 8.41288 7.18362C9.06089 6.9152 9.61476 6.46065 10.0044 5.87746C10.3941 5.29426 10.6021 4.60861 10.6021 3.9072C10.6021 2.96665 10.2285 2.06462 9.56341 1.39955C8.89833 0.734473 7.9963 0.36084 7.05575 0.36084Z"
                    fill="#0088C2" />
                </svg>
                {{ userName ? userName : 'Company' }}</a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <router-link class="dropdown-item" to="/company-profile"><i class="fa fa-expeditedssl"></i> My
                  profile</router-link>
                <router-link class="dropdown-item" to="/subscription"><i class="fa fa-expeditedssl"></i> My
                  Subscription</router-link>
                <router-link class="dropdown-item" to="/postjoblist"><i class="fa fa-expeditedssl"></i> My
                  Jobs</router-link>
                <span class="dropdown-item" @click="onLogout"> Logout</span>
              </div>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link active respo-text-center" to="/dashboard" data-toggle="tooltip"
                title="Dashboard"><svg width="17" height="16" viewBox="0 0 13 12" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.5 0C9.8 0 12.5 2.7 12.5 6C12.5 9.3 9.8 12 6.5 12C3.2 12 0.5 9.3 0.5 6C0.5 2.7 3.2 0 6.5 0ZM9.275 3.225C9.125 3.075 8.975 3.075 8.825 3.15C7.1 4.35 6.125 5.1 5.9 5.325C5.525 5.7 5.525 6.225 5.9 6.6C6.275 6.975 6.8 6.975 7.175 6.6C7.325 6.45 8 5.475 9.35 3.675C9.425 3.525 9.35 3.375 9.275 3.225ZM9.8 5.4C9.425 5.4 9.2 5.625 9.2 6C9.2 6.375 9.425 6.6 9.8 6.6C10.175 6.6 10.4 6.375 10.4 6C10.4 5.625 10.175 5.4 9.8 5.4ZM3.2 5.4C2.825 5.4 2.6 5.625 2.6 6C2.6 6.375 2.825 6.6 3.2 6.6C3.575 6.6 3.8 6.375 3.8 6C3.8 5.625 3.575 5.4 3.2 5.4ZM4.55 3.225C4.325 3 3.95 3 3.725 3.225C3.5 3.45 3.5 3.825 3.725 4.05C3.95 4.275 4.325 4.275 4.55 4.05C4.85 3.825 4.85 3.45 4.55 3.225ZM6.5 2.1C6.125 2.1 5.9 2.325 5.9 2.7C5.9 3.075 6.125 3.3 6.5 3.3C6.875 3.3 7.1 3.075 7.1 2.7C7.1 2.325 6.875 2.1 6.5 2.1Z"
                    fill="#008FCC" />
                </svg>
                Dashboard</router-link>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    <div id="login-modal">
      <LoginModal v-if="showLoginModal" :showModal="showLoginModal" @close="showLoginModal = false"
        @change-route="changeRoute" />
    </div>
  </div>
</template>

<script>
import LoginModal from "@/components/Modal/LoginModal.vue";
import "@/assets/fonts/stylesheet.css";

import Cookies from "js-cookie";
/* eslint-disable */
export default {
  name: "Header",
  components: {
    LoginModal,
  },
  watch: {
    $route(to) {
      // console.log("TO PATH", to);
      // console.log("From PATH", from);
      this.userName = localStorage.getItem('companyName') ? localStorage.getItem('companyName') : Cookies.get("companyName") ; 
      this.currentPath = to.path;
      window.scrollTo(0, 0);
    },
  },
  data() {
    return {
      showLoginModal: false,
      userName: "",
      isNav: true,
      currentPath: "",
    };
  },
  mounted() {
    this.userName = localStorage.getItem('companyName') ? localStorage.getItem('companyName') : Cookies.get("companyName"); 
    this.currentPath = this.$router.currentRoute.path;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  methods: {
    changeRoute() {
      if (
        this.prevRoute &&
        this.prevRoute.path &&
        this.prevRoute.path !== "/"
      ) {
        this.$router.push(this.prevRoute.path);
      } else {
        this.$router.push("/dashboard");
      }
    },
    clickOnLogin() {
      // alert('jhjsjash');
      // this.showLoginModal = true;
      this.$router.push("/login");
    },
    clickOnPostJob() {
      this.$router.push("/post-job");
    },
    clickOnCompProf() {
      this.$router.push("/company-profile");
    },
    onLogout() {
      this.userName = "";
      var now = new Date();
      localStorage.removeItem('companyName')
      Cookies.remove("userId", { path: "/", expires: now.toGMTString() });
      Cookies.remove("authToken", { path: "/", expires: now.toGMTString() });
      Cookies.remove("companyName", { path: "/", expires: now.toGMTString() });
      Cookies.remove("mobileNumber", { path: "/", expires: now.toGMTString() });
      Cookies.remove("contactPerson", {
        path: "/",
        expires: now.toGMTString(),
      });
      this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.respo-text-center {
  text-align: center !important;
}

.nav-link:hover {
  text-decoration: none;
}
</style>
